import React from 'react';
import { ProblemSolution } from '../components/ProblemSolution';
import { Testimonials } from '../components/Testimonials';
import { Contact } from '../components/Contact';
import { PageHeader } from '../components/PageHeader';

export const WhyUs: React.FC = () => {
  return (
    <div className="animate-fade-in-up">
      <PageHeader 
        title="Why//Zackig?" 
        subtitle="Manifesto" 
      />
      <div className="bg-brand-gray">
        <ProblemSolution />
      </div>
      <Testimonials />
      <Contact />
    </div>
  );
};